export { effectivePermissionsScreen, notificationSettingsScreen, profileScreen } from './profile.screen';
export { notificationSettingsSearch, profileSearch } from './profile.search';
export { loadProfileMessages } from './profile.catalog';
export { ProfileSessionProvider, type ChangePasswordResult, type ProfileSession } from './profile.session';
export const loadProfileScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadProfileGuides = () => import('./profile.guide');
